import Vue from 'vue';
import moment from 'moment';

Vue.prototype.$moment = moment;
if (!window.moment) window.moment = moment;
window.$moment = moment;
